import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ReactComponent as CloseBtn } from "assets/common/modal/closeIcon.svg";
import { postOnelineNotice } from "service/api/notice";
import responseCodeConstant from "service/constant/responseCodeConstant";
import { KeyedMutator } from "swr";

interface Props {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  mutate: KeyedMutator<any>;
}

export function AddModal({ isVisible, setIsVisible, mutate }: Props) {
  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    if (isVisible) {
      setInputValue("");
    }
  }, [isVisible]);

  const handleCancelBtn = () => {
    setIsVisible(false);
  };

  const handleNoticeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleAddBtn = async () => {
    const addRes = await postOnelineNotice(inputValue);
    if (addRes.status === responseCodeConstant.SUCCESS.ok) {
      mutate();
      setIsVisible(false);
    }
  };

  return (
    <Transition.Root show={isVisible} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[999999999999]"
        onClose={handleCancelBtn}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-80 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-[20px]">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="transition-al relative mx-auto h-[370px] w-[1031px] transform rounded-[12px] bg-white p-[48px] pb-[32px]">
                <CloseBtn
                  onClick={handleCancelBtn}
                  className="absolute right-[40px] top-[40px] cursor-pointer"
                />
                <p className="m-0 mb-[32px] text-[28px] font-semibold">
                  한줄 공지 추가하기
                </p>
                <p className="m-0 mb-[16px] text-[24px] font-semibold">
                  메인 화면에 들어갈 한 줄 공지를 적어주세요.
                </p>
                <input
                  value={inputValue}
                  onChange={handleNoticeInput}
                  className="m-0 mb-[6px] h-[54px] w-full rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] text-[18px] font-medium outline-none placeholder:text-[#c6c6c6] focus:border-gray-5 focus:ring-0"
                  placeholder="ex: 메모리올이 정식 오픈되었습니다."
                  maxLength={65}
                />
                <p className="m-0 mb-[19px] text-right text-[16px] font-semibold text-[#a3a3a3]">
                  {inputValue.length}/65자
                </p>
                <div className="flex items-center gap-[9px]">
                  <button
                    className="h-[73px] w-[462px] rounded-[16px] border-[1px] border-gray-5 bg-white text-[18px] font-semibold text-gray-5"
                    onClick={handleCancelBtn}
                  >
                    취소하기
                  </button>
                  <button
                    className="h-[73px] w-[462px] rounded-[16px] border-[1px] border-blue-1 bg-blue-1 text-[18px] font-semibold text-white"
                    onClick={handleAddBtn}
                  >
                    저장하기
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
